package org.example.project.enginevertrieb

internal fun linkedInConnectedDate(value: String): String {
    val raw = value.trim()
    if (raw.isBlank()) return ""
    Regex("^(\\d{4})-(\\d{2})-(\\d{2})(?:$|T| )").find(raw)?.let {
        return "${it.groupValues[3]}.${it.groupValues[2]}.${it.groupValues[1]}"
    }
    Regex("^(\\d{1,2})[. /-](\\d{1,2})[. /-](\\d{4})$").matchEntire(raw)?.let {
        return "${it.groupValues[1].padStart(2, '0')}.${it.groupValues[2].padStart(2, '0')}.${it.groupValues[3]}"
    }
    val date = kotlin.js.Date(raw)
    if (date.getTime().isNaN()) return raw
    return "${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}"
}
